export default "__VITE_ASSET__D6pBX3AC__"